export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },

  {
    title: '真实姓名',
    dataIndex: 'user_realname',
  },
  {
    title: '手机号',
    dataIndex: 'mobile',
  },
  {
    title: '医院',
    dataIndex: 'hospital',
  },
  {
    title: '科室',
    dataIndex: 'department_name',
  },
  {
    title: '职称',
    dataIndex: 'professional_name',
  },
  {
    title: '激活状态',
    dataIndex: 'doctor_status',
    customRender: (text, record, index)=>{
      return record.doctor_status===0?'未激活':'已激活';
    },
  },
  {
    title: '认证状态',
    dataIndex: 'check_status',
    customRender: (text, record, index)=>{
      if(record.check_status===1){
        return '未验证';
      }
      if(record.check_status===2){
        return '审核中';
      }
      if(record.check_status===4){
        return '通过';
      }
      if(record.check_status===3){
        return '未通过';
      }
    },

  },
  {
    title: '参与推广数量',
    dataIndex: 'doctor_task_count',
    scopedSlots: { customRender: 'doctor_task_count' },
  },
  {
    title: '推广员数量',
    dataIndex: 'promoters_count',
    scopedSlots: { customRender: 'promoters_count' },
  },
  // {
  //   title: '学分',
  //   dataIndex: 'company_score',
  //   scopedSlots: { customRender: 'company_score' },
  // },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];


export const columns1 = [
  {
    title: 'Excel行号',
    align:'center',
    dataIndex: 'line',
	  width:'8%'
  },

  {
    title: '医生姓名',
    dataIndex: 'user_realname',
	width:'8%'
  },
  {
    title: '医生性别',
    dataIndex: 'sex',
	  width:'6%'
  },
  {
    title: '医生手机号',
    dataIndex: 'mobile',
	width:'10%'
  },
  {
    title: '医院',
    dataIndex: 'hospital',
	width:'18%'
  },
  {
    title: '所属科室',
    dataIndex: 'department_name',
	width:'10%'
  },
  {
    title: '职称',
    dataIndex: 'professional_name',
	width:'10%'
  },
  {
    title: '关联代表手机号',
    dataIndex: 'promoter_mobiles',
	width:'12%'
  },
	{
	  title: '反馈信息',
	  dataIndex: 'error_msg',
		scopedSlots: { customRender: 'error_msg' },
		width:'18%'
	},
];

export const formData = [
	// {
	// 	  name: 'company_id',
	// 	  lable: '合作企业',
	// 	  lableCol: 4,
	// 	  wrapperCol: 18,
	// },
  {
    name: 'user_realname',
    lable: '真实姓名',
    lableCol: 4,
    wrapperCol: 18,
  },

  {
    name: 'sex',
    lable: '性别',
    lableCol: 4,
    wrapperCol: 18,
  },
  // {
  //   name: 'promoters',
  //   lable: '选择推广员',
  //   lableCol: 4,
  //   wrapperCol: 18,
  // },
  // {
  //   name: 'provinceCity',
  //   lable: '地区',
  //   lableCol: 4,
  //   wrapperCol: 18,
  // },
  // {
  //   name: 'address',
  //   lable: '详细地址',
  //   lableCol: 4,
  //   wrapperCol: 18,
  // },
  {
    name: 'mobile',
    lable: '医生手机号',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'hospital_id',
    lable: '医院',
    lableCol: 4,
    wrapperCol: 18,
  },
  // {
  //   name: 'speciality',
  //   lable: '擅长',
  //   lableCol: 4,
  //   wrapperCol: 18,
  // },
  {
    name: 'department_id',
    lable: '所属科室',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'professional_id',
    lable: '职称',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'promoters',
    lable: '关联临床推广的药代表',
    lableCol: 8,
    wrapperCol: 14,
  },
];

export const approveFormData1 = [
  {
    name: 'check_status',
    lable: '是否同意',
    lableCol: 4,
    wrapperCol: 18,
  },
];
export const approveFormData2 = [
  {
    name: 'check_status',
    lable: '是否同意',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'reasons',
    lable: '说明',
    lableCol: 4,
    wrapperCol: 18,
  },
];